import React from 'react';
import UserSource from '../../sources/user';
import '../../../css/login.less';
import BrandedModal from './BrandedModal';
import Loader from '../Loader';

class Login extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: this.props.username || '',
            usernameError: '',
            loading: null,
            faults: null,
        };
    }

    componentWillMount() {
        try {
            this.setState({
                username: localStorage.getItem('manywho-draw-login-username') || '',
            });
        } catch (ex) {
            // handle the error eventually
        }
    }

    componentDidMount() {
        if (this.refs.username) {
            this.refs.username.focus();

            if (this.props.username) {
                this.refs.username.setSelectionRange(0, this.props.username.length);
            }
        }
    }

    onUsernameChange = (e) => {
        this.setState({ username: e.target.value });
    };

    onKeyUp = (e) => {
        if (e.keyCode && e.keyCode === 13) {
            this.onSubmit();
        }
    };

    dismiss = () => {
        this.setState({ faults: null });
    };

    onSubmit = () => {
        if (this.state.username !== '') {
            this.setState({ loading: { message: '' }, usernameError: '' });

            UserSource.login(this.state.username, null)
                .then((response) => {
                    this.setState({ loading: null });

                    if (this.props.callback) {
                        this.props.callback.call(null, response, this.state.username);
                    }

                    localStorage.setItem('manywho-draw-login-username', this.state.username);
                    document.cookie = `boomi-flow-token=${response}`;
                    window.location.reload();
                })
                .catch((error) => {
                    this.setState({
                        loading: null,
                        faults: error.message,
                    });
                });
        } else {
            this.setState({ usernameError: 'This field is required.' });
        }
    };

    render() {
        manywho.log.info('Rendering Login');

        let faults = null;
        if (this.state.faults) {
            faults = (
                <div className="notification alert alert-danger">
                    <button className="close" onClick={this.dismiss}><span>{'\u00D7'}</span></button>
                    <span>{this.state.faults}</span>
                </div>
            );
        }

        let usernameClassName = 'form-group';

        if (this.state.usernameError !== '') {
            usernameClassName += ' has-error';
        }

        return (
            <BrandedModal>                        
                <div className="modal-body">
                    {faults}
                    <div className={usernameClassName}>
                        <label>
                            Email
                            <span className="input-required"> *</span>
                        </label>
                        <input
                            type="text"
                            maxLength={255}
                            size={60}
                            className="form-control"
                            ref="username"
                            value={this.state.username}
                            onChange={this.onUsernameChange}
                            onKeyUp={this.onKeyUp}
                        />
                        <span className="help-block">{this.state.usernameError}</span>
                    </div>
                </div>
                <div className="modal-footer">
                    <div><button className="btn boomi-login-button" onClick={this.onSubmit}>Log In</button></div>
                </div>                        
                {
                    this.state.loading ? <Loader message={this.state.loading.message} /> : null
                }
            </BrandedModal> 
        );
    }
}

export default Login;